import {
  faTrashCan,
  faClockRotateLeft,
  faFileCsv,
} from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export type LobTab = "active" | "archived";

export interface BatchActionHandlers {
  onDelete: () => void;
  onRestore: () => void;
  onExport: () => void;
}

export const buildLobBatchActions = (
  tab: LobTab,
  _selectedCount: number,
  handlers: BatchActionHandlers,
  isDownloading = false
): BatchAction[] =>
  tab === "archived"
    ? [
        {
          icon: faClockRotateLeft,
          label: "Restore",
          onClick: handlers.onRestore,
        },
      ]
    : [
        {
          icon: faFileCsv,
          label: "Export CSV",
          onClick: handlers.onExport,
          disabled: isDownloading,
        },
        {
          icon: faTrashCan,
          label: "Delete",
          onClick: handlers.onDelete,
          variant: "danger",
        },
      ];
